<template>
  <button @click="toggleLocation()">
    <AtomSwitch :active="fat.hasUserLocation" :loading="isLoading" :spinner="true" />
  </button>
</template>

<script setup>
const route = useRoute()
const router = useRouter()
const fat = useFatStore()
const user = useUserStore()
const isLoading = ref(false)

// Toggle location
const toggleLocation = () => {
  // console.log('toggleLocation')

  fat.hasUserLocation
    ? resetLocation()
    : getLocation()
}

// Reset user and FAT location
const resetLocation = () => {
  // console.log('resetLocation')

  user.resetLocation()
  fat.latitude = null
  fat.longitude = null
}

// Get location and update user store
const getLocation = async () => {
  // console.log('getLocation')

  isLoading.value = true
  await user.getLocation()
  await useDelay(500)
  isLoading.value = false

  if (user.allowLocation) {
    setFatLocation()
  }
}

// Update FAT with user location 
const setFatLocation = () => {
  const location = `${user.latitude},${user.longitude},${fat.distance}`
  if (route.name.startsWith('fat')) {
    useUpdateQuery({ location: location, locationModal: undefined })
  } else {
    fat.latitude = user.latitude
    fat.longitude = user.longitude
    fat.distance = 3000
  }
}
</script>

<style lang="scss" scoped>
// 
</style>